import(/* webpackMode: "eager" */ "/opt/jckauto-site/jck-auto/node_modules/@fontsource-variable/inter/index.css");
;
import(/* webpackMode: "eager" */ "/opt/jckauto-site/jck-auto/node_modules/@fontsource-variable/space-grotesk/index.css");
;
import(/* webpackMode: "eager" */ "/opt/jckauto-site/jck-auto/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/FloatingMessengers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/layout/LeadAttributionCapture.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/layout/YandexMetrika.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/MotionProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/jckauto-site/jck-auto/src/components/promo/PromoGate.tsx");
